var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubheading = function SvgSubheading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "subheading_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".subheading_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.7 9.5 2.6c-.1-.2-.4-.4-.7-.3l-.3.3L2 21.7M4.4 14.7h9.2M.5 21.7h3M14.5 21.7h3M22.5 21.7 18.4 9.6c-.1-.3-.4-.4-.6-.3-.1.1-.3.2-.3.3l-1.9 5.5M16.9 16.7h3.9M21.5 21.7h2",
    className: "subheading_svg__st0"
  })));
};
export default SvgSubheading;